<template>
  <div class="table-pager-wrapper">
    <fieldset
        class="table-pager align-items-center"
        :disabled="pagination.loading"
    >
      <div
          class="pager-button btn-first"
          @click="pagination.firstPage"
      >Начало</div>
      <div
          class="pager-button btn-back"
          @click="pagination.decPage"
      >Назад</div>
      <div class="info">
        <span class="info__text">Страница {{ (pagination.currentPage.value + 1)}} из {{pagination.countPages.value}}</span>
      </div>
      <div
          class="pager-button btn-forward"
          @click="pagination.incPage"
      >Вперёд</div>
      <div
          class="pager-button btn-last"
          @click="pagination.lastPage"
      >Конец</div>
      </fieldset>
      <div v-if="pagination.setPerPage" class="per-page">
          <input
              id="perPageInput"
              class="per-page__input"
              type="number"
              min="1"
              :value="localPerPage"
              @input="localPerPage = $event.target.value"
              @change="pagination.setPerPage(localPerPage)"
          />
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";

export default {
  name: "TablePager",
  props: ['pagination'],
  setup(props) {
    const localPerPage = ref(props.pagination.perPage?.value ?? props.pagination.perPage);

    watch(() => props.pagination.perPage?.value ?? props.pagination.perPage, (val) => {
      localPerPage.value = val;
    });

    return { localPerPage };
  }
}
</script>

<style lang="scss" scoped>
.table-pager-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0 auto;
}

.table-pager {
  display: grid;
  grid-template-columns: 48px 48px 1fr 48px 48px;
  column-gap: 10px;
  align-items: center;
  line-height: 13px;
  background-color: var(--cd-button-bg-color);
  border-radius: var(--cd-button-border-radius);
  border: none;
  padding: 10px;
  margin: 0 auto;
}

.info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: var(--cd-default-font);
  font-size: var(--cd-default-font-size);

  &__text {
    white-space: nowrap;
    flex: 1;
    text-align: center;
  }
}

.per-page {
  font-family: var(--cd-default-font);
  font-size: 13px;
  color: var(--cd-text-muted);

  &__input {
    width: 60px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid var(--cd-field-border);
    background: var(--cd-field-bg);
    color: var(--cd-field-color);
    padding: 0 8px;
    font-size: 13px;
    text-align: center;

    &:focus {
      outline: none;
      border-color: var(--cd-base-green);
    }
  }
}
.pager-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 8px;
  font-family: var(--cd-default-font);
  font-size: 13px;
  color: var(--cd-text);
  background: var(--cd-button-bg-color);
  border: 1px solid var(--cd-field-border);
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;

  &:hover {
    background: var(--cd-button-bg-hover, var(--cd-field-bg-hover));
  }
}
</style>
